<template>
  <div class="power-user">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
      <el-form-item>
        <el-input v-model="dataForm.roleName" placeholder="岗位名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getDataList(1)">查询</el-button>
      </el-form-item>
    </el-form>

    <el-button type="primary" class="addBtn" @click="addOrUpdateHandle()">新增岗位</el-button>

    <el-table :data="dataList" border v-loading="dataListLoading" style="width: 100%;">
      <el-table-column prop="roleName" align="center" min-width="150" label="岗位名称"></el-table-column>
      <!-- <el-table-column prop="menuIdList" align="center" min-width="150" label="权限范围"></el-table-column> -->
      <el-table-column align="center" min-width="150" label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.roleId)">编辑</el-button>
          <el-button type="text" size="small" @click="deleteHandle(scope.row.roleId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <power-edit v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></power-edit>
  </div>
</template>

<script>
import powerEdit from "./comm/powerEdit";
import { roleListData } from "@/api/list";
import { roleDelete } from "./api";
export default {
  components: {
    powerEdit,
  },
  data() {
    return {
      dataForm: {
        roleName: "",
        menuIdList: ""
      },
      dataList: [{userId:0}],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
    };
  },
  mounted() {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    getDataList(page) {
      this.dataListLoading = true;
      roleListData({
        page: page || this.pageIndex,
        limit: this.pageSize,
        roleName: this.dataForm.roleName,
      }).then( data => {
        if (data && data.code === 0) {
          this.dataList = data.page.list;
          this.totalPage = data.page.totalCount;
        } else {
          this.dataList = [];
          this.totalPage = 0;
          this.$message.error(data.msg);
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 重置
    cleaList() {
      this.dataForm = {};
      this.pageIndex = 1;
      this.getDataList();
    },
    // 删除
    deleteHandle(id) {
      var userIds = id
        ? [id]
        : this.dataListSelections.map((item) => {
            return item.userId;
          });
      this.$confirm(
        `确定进行删除操作?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          roleDelete(
            userIds
          ).then( data => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.getDataList();
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.addBtn {
  margin-bottom: 20px;
}
</style>